// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2740":"3474ec4e2fa6406b","2907":"50c2423848751294","2997":"ed300a33038a6f09","3846":"17c21d0ca379c7cc","5585":"2bbbdc69a7d83780","8930":"27fb3c36a4b5732b","8975":"e4ba6384c44cc228"}[chunkId] + ".js";
};